'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESInput = undefined;

var _ButtonGroup = require('./ButtonGroup');

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _Password = require('./Password');

var _Password2 = _interopRequireDefault(_Password);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

var _Number = require('./Number');

var _Number2 = _interopRequireDefault(_Number);

var _TextArea = require('./TextArea');

var _TextArea2 = _interopRequireDefault(_TextArea);

var _Toggle = require('./Toggle');

var _Toggle2 = _interopRequireDefault(_Toggle);

var _Translation = require('./Translation');

var _Translation2 = _interopRequireDefault(_Translation);

var _CapitalText = require('./CapitalText');

var _CapitalText2 = _interopRequireDefault(_CapitalText);

var _InputButtonGroupNumber = require('./InputButtonGroupNumber');

var _InputButtonGroupNumber2 = _interopRequireDefault(_InputButtonGroupNumber);

var _InputButtonGroupText = require('./InputButtonGroupText');

var _InputButtonGroupText2 = _interopRequireDefault(_InputButtonGroupText);

var _Email = require('./Email');

var _Email2 = _interopRequireDefault(_Email);

var _InputButtonGroupEmail = require('./InputButtonGroupEmail');

var _InputButtonGroupEmail2 = _interopRequireDefault(_InputButtonGroupEmail);

var _InputButtonGroupSelect = require('./InputButtonGroupSelect');

var _InputButtonGroupSelect2 = _interopRequireDefault(_InputButtonGroupSelect);

var _LockableText = require('./LockableText');

var _LockableText2 = _interopRequireDefault(_LockableText);

var _LockableNumber = require('./LockableNumber');

var _LockableNumber2 = _interopRequireDefault(_LockableNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {Translated} from "@esnpm/translate"

var ESInput = exports.ESInput = {};
ESInput.Text = _Text2.default;
ESInput.CapitalText = _CapitalText2.default;
ESInput.Select = _Select2.default;
ESInput.ButtonGroup = _ButtonGroup2.default;
ESInput.Number = _Number2.default;
ESInput.TextArea = _TextArea2.default;
ESInput.Translation = _Translation2.default;
ESInput.Password = _Password2.default;
ESInput.Toggle = _Toggle2.default;
ESInput.InputButtonGroupNumber = _InputButtonGroupNumber2.default;
ESInput.InputButtonGroupText = _InputButtonGroupText2.default;
ESInput.InputButtonGroupEmail = _InputButtonGroupEmail2.default;
ESInput.Email = _Email2.default;
ESInput.InputButtonGroupSelect = _InputButtonGroupSelect2.default;
ESInput.LockableText = _LockableText2.default;
ESInput.LockableNumber = _LockableNumber2.default;

//Todo: RadioGroup
//Todo: Checkbox
//Todo: RangeInput
//Todo: PriceInput
//Todo: NumberInput